import React, { useState, useEffect } from "react";
import api from "../../api";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import ReactSelect from "react-select";
import { Button, Dialog, DialogContent, TextField } from "@material-ui/core";
import { PaymentMethodTypes } from "../../enums/enums";

export default function PaymentMethodEdit({
  id,
  classes,
  setIsLoading,
  setDataToast,
  setOpenEdit,
  shortError,
  openEdit,
  paymentMethods,
  reloadData,
  itemsPerPage,
}) {
  const [defaultValues, setDefaultValues] = useState();

  useEffect(() => {
    getPaymentMethod(id);
  }, []);

  const getPaymentMethod = (id) => {
    setIsLoading(true);
    api
      .getTypePaymentMethod(id)
      .then((res) => {
        let paymentMethod = res.data;
        setDefaultValues({
          id: paymentMethod.paymentMethodId,
          name: paymentMethod.paymentMethodName,
          paymentMethod: {
            key: paymentMethod.paymentMethodTypeId,
            value: paymentMethod.paymentMethodTypeId,
            label: paymentMethods.find((x) => x.key ===  paymentMethod.paymentMethodTypeId).label,
          },
          paymentProcessor: paymentMethod.paymentProcessorName,
          numEntityPayment: paymentMethod.sapEntityPaymentId,
          numFormPayment: paymentMethod.sapPaymentMethodId,
        });
        setIsLoading(false);
      })
      .catch((err) => {
        setDefaultValues(undefined);
        shortError("Ocurrió un error.");
        setIsLoading(false);
      });
  };

  const handleInputChangeTypePaymentMethod = (e) => {
    setDefaultValues({ ...defaultValues, paymentMethod: e });
  };

  const handleImputChangeEdit = (e) => {
    setDefaultValues({ ...defaultValues, name: e.target.value });
  };
  const handleImputChangeEditNumEntidad = (e) => {
    if (e.target.value > 0) {
      setDefaultValues({ ...defaultValues, numEntityPayment: e.target.value });
    } else {
      setDefaultValues({ ...defaultValues, numEntityPayment: "" });
    }
  };

  const handleImputChangeEditNumForm = (e) => {
    if (e.target.value > 0) {
      setDefaultValues({ ...defaultValues, numFormPayment: e.target.value });
    } else {
      setDefaultValues({ ...defaultValues, numFormPayment: "" });
    }
  };

  const ConfirmEditPaymentMethod = () => {
    setIsLoading(true);
    if (checkValueCreatePaymentMethod()) {
      var body = {
        nombreMedioDePago: defaultValues.name.trim(),
        tipoMedioDePago: defaultValues.paymentMethod.key,
        entidadPagoSapId: defaultValues.numEntityPayment !== null ? parseInt(defaultValues.numEntityPayment) : null,
        formaPagoSapId: defaultValues.numFormPayment !== null ? parseInt(defaultValues.numFormPayment) : null,
      };
      api
        .putPaymentMethod(defaultValues.id, body)
        .then((res) => {
          setIsLoading(false);
          setDataToast({
            active: true,
            message: "Medio de Pago editado correctamente.",
            type: "success",
          });
          reloadData(1, 1, itemsPerPage, true);
        })

        .catch((err) => {
          setIsLoading(false);
          setDataToast({
            active: true,
            message: err.response.data.errores ?? "Ocurrió un error.",
            type: "error",
          });
        });
      setOpenEdit({ open: false });
    } else if (!defaultValues.name.trim()) {
      shortError("Debe ingresar un Nombre");
      setIsLoading(false);
    }
    if (!defaultValues.paymentMethod) {
      shortError("Debe seleccionar un Medio de Pago");
      setIsLoading(false);
    }
    if (
      defaultValues.paymentMethod.key !== PaymentMethodTypes.Cash.Id &&
      (!defaultValues.numEntityPayment && defaultValues.numEntityPayment !== "")
    ) {
      shortError("Debe ingresar Numero de Entidad de pago sap");
      setIsLoading(false);
    }
    if (
      defaultValues.paymentMethod.key !== PaymentMethodTypes.Cash.Id &&
      (!defaultValues.numFormPayment && defaultValues.numFormPayment !== "")
    ) {
      shortError("Debe ingresar Numero de Forma de pago sap");
      setIsLoading(false);
    }
  };

  const checkValueCreatePaymentMethod = () => {
    let response = false;

    if (defaultValues.paymentMethod.key === PaymentMethodTypes.Cash.Id) {
      return defaultValues.name.trim() ? (response = true) : (response = false);
    } else if (
      defaultValues.name.trim() &&
      defaultValues.paymentMethod &&
      defaultValues.numEntityPayment &&
      defaultValues.numFormPayment
    ) {
      response = true;
    }

    return response;
  };

  return (
    <>
      {defaultValues && (
        <Dialog
          open={openEdit}
          onClose={() => {
            setOpenEdit({ open: false });
          }}
          aria-labelledby="form-dialog-title"
          fullWidth={true}
          classes={{
            paperFullWidth: classes.paperFullWidth,
          }}
        >
          <DialogTitle id="form-dialog-title">Editar Registro</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              id="name"
              type="text"
              name="nombre"
              label="Nombre medio de pago"
              onChange={handleImputChangeEdit}
              value={defaultValues.name}
              fullWidth
              required
            />
          </DialogContent>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              id="name"
              label="Numero entidad de pago sap"
              type="number"
              name="numEntidad"
              onChange={handleImputChangeEditNumEntidad}
              value={defaultValues.numEntityPayment}
              fullWidth
              required={defaultValues.paymentMethod.key !== PaymentMethodTypes.Cash.Id}
            />
          </DialogContent>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              id="name"
              label="Numero forma de pago sap"
              type="number"
              name="numFormulario"
              onChange={handleImputChangeEditNumForm}
              value={defaultValues.numFormPayment}
              fullWidth
              required={defaultValues.paymentMethod.key !== PaymentMethodTypes.Cash.Id}
            />
          </DialogContent>
          <DialogContent
            classes={{
              root: classes.dialogContentRoot,
            }}
            style={{ maxWidth: 300, marginTop: 15 }}
          >
            <small></small>
            <ReactSelect
              styles={{ maxWidth: 350 }}
              placeholder="Medio de Pago..."
              options={paymentMethods}
              onChange={handleInputChangeTypePaymentMethod}
              value={defaultValues.paymentMethod}
              required
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setOpenEdit({ open: false });
                setDefaultValues(undefined);
              }}
              className="c-btn-cancel"
            >
              Cancelar
            </Button>
            <Button type="submit" onClick={() => ConfirmEditPaymentMethod()} className="c-btn-success">
              Aceptar
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
}
